module.exports = __webpack_public_path__ + "img/modal-notcomplete-icon.2e4e799b.svg";